/** The value the text parsed to, or why it could not be parsed. */
export type ParsedFormTemplate =
  | { ok: true; value: unknown }
  | { ok: false; message: string }

const NOT_JSON_MESSAGE =
  'The definition is not valid JSON, so it could not be read. Check for a missing ' +
  'comma, quote, or bracket.'

/**
 * Read the definition box. Refuses only text that is not JSON at all — whether a
 * JSON value is a usable form is the API's judgement, not this one's.
 */
export const parseFormTemplate = (text: string): ParsedFormTemplate => {
  try {
    return { ok: true, value: JSON.parse(text) }
  } catch (error) {
    const detail = error instanceof Error ? error.message : ''
    return { ok: false, message: detail ? `${NOT_JSON_MESSAGE} (${detail})` : NOT_JSON_MESSAGE }
  }
}
